import React from 'react';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { lazyLoad } from 'utils/loadable';

export const Reservation = lazyLoad(
  () => import('./page'),
  module => module.ReservationPage,
  { fallback: <LoadingContainer loading /> },
);
